const FullWidthContainer = ({ children }) => (
  <div className="relative w-screen right-[50%] left-[50%] -mx-[50vw]">
    {children}
  </div>
);

export default FullWidthContainer;
